/**
 * Created by aleks on 19/04/2017.
 */
export enum CardType
{
  /// <summary>
  /// Карта не вставлена
  /// </summary>
  NO = 1, // Карта не вставлена

    /// <summary>
    /// Карта водителя
    /// </summary>
  CD, // Карта водителя

    /// <summary>
    /// Карта мастерской
    /// </summary>
  CM, // Карта мастерской

    /// <summary>
    /// Карта контролера
    /// </summary>
  CC, // Карта контролера

    /// <summary>
    /// Карта предприятия
    /// </summary>
  CI // Карта предприятия
}

export enum ActivityType
{
  /// <summary>
  /// управление
  /// </summary>
  Driving = 1, // управление

    /// <summary>
    /// Работа
    /// </summary>
  Work, // Работа

    /// <summary>
    /// Готовность
    /// </summary>
  Availability, // Готовность

    /// <summary>
    /// Перерыв
    /// </summary>
  Break, // Перерыв

    /// <summary>
    /// Отдых
    /// </summary>
  Rest // Отдых
}



export class TachoData{

  constructor(
    // AS: slot number (1 or 2)
    public slot: Number,

    // AS: card number
    public cardNumber: string,

    public cardType: Number,

    // AS: current activity type
    public activity: Number,

    // AS: driving time in current session
    public drivingDuration: Number,

    // AS: total time of breaks
    public breaksTotal: Number,

    // AS: time of current activity
    public currentActivityTypeTime: number
  )
  {
  }

  private activityToString(): string{
    switch(this.activity){
      case ActivityType.Driving:
        return "управление";
      case ActivityType.Availability:
        return "готовность";
      case ActivityType.Break:
        return "перерыв"
      case ActivityType.Rest:
        return "отдых";
      case ActivityType.Work:
        return "работа";
    }

    return "";
  }

  private cardTypeToString(): string{
    switch(this.cardType) {
      case CardType.CC:
        return "контроллер";
      case CardType.CD:
        return "водитель";
      case CardType.CI:
        return "предприятие";
      case CardType.CM:
        return "мастерская";
      case CardType.NO:
        return "нет карты";
    }
    return "";
  }

  public toString(): string{
    let res: string = "";
    res =
      //"Слот " + this.slot + ": " +
      (this.cardNumber || "") + " (" + this.cardTypeToString() + "), " +
      this.activityToString();

    return res;
  }

  public static parse(slot: string): TachoData{
    if(!slot || slot === undefined){
      return null;
    }
    let tis = slot.split(',');
    if(tis.length != 7){
      return null;
    }

    let slotNumber = Number(tis[0]);
    let cardNumber = tis[1];
    let cardType: Number;
    let activityType; Number;

    switch(tis[2].toLowerCase()){
      case "":
      case "no":
        cardType = CardType.NO;
        cardNumber = null;
        break;
      case "cd":
        cardType = CardType.CD;
        break;
      case "cm":
        cardType = CardType.CM;
        break;
      case "cc":
        cardType = CardType.CC;
        break;
      case "ci":
        cardType = CardType.CI;
        break;
    }

    switch (tis[3].toLowerCase())
    {
      case "d":
        activityType = ActivityType.Driving;
        break;
      case "w":
        activityType = ActivityType.Work;
        break;
      case "a":
        activityType = ActivityType.Availability;
        break;
      case "b":
        activityType = ActivityType.Break;
        break;
      case "r":
        activityType = ActivityType.Rest;
        break;
    }

    let drivingDuration = Number(tis[4]);
    let breaksTotal = Number(tis[5]);
    let currentActivityTypeTime = Number(tis[6]);

    let tdat = new TachoData(
      slotNumber,
      cardNumber,
      cardType,
      activityType,
      drivingDuration,
      breaksTotal,
      currentActivityTypeTime
    );

    return tdat;
  }

}



// WEBPACK FOOTER //
// ./src/app/tacho-data.ts